import React from "react";
import AdminFeatureTour, {
  markTourSeen,
  shouldAutoStartTour,
} from "../../components/AdminFeatureTour";

export const THEMEUPDATE_TOUR_STORAGE_KEY = "sl_admin_themeupdate_tour_seen_v1";

export const THEMEUPDATE_TOUR_STEPS = [
  {
    id: "welcome",
    target: "tour-gc-header",
    title: "Game Settings",
    body: "Switch between Game Settings (bins and bin icons) and Conveyor Belt Item Images (the waste items for each bin and the belt image).",
  },
  {
    id: "settings",
    target: "tour-gc-settings",
    title: "Bins & images",
    body: "Add custom bins, choose 2 to 5 active bins and upload 400x400 PNG icons. On the items tab, upload up to 15 PNG items (200x200) per bin and one 1938x211 conveyor belt image.",
  },
];

export default function ThemeUpdateFeatureTour({ open, onClose }) {
  return <AdminFeatureTour open={open} onClose={onClose} steps={THEMEUPDATE_TOUR_STEPS} />;
}

export function markThemeUpdateTourSeen() {
  markTourSeen(THEMEUPDATE_TOUR_STORAGE_KEY);
}

export function shouldAutoStartThemeUpdateTour() {
  return shouldAutoStartTour(THEMEUPDATE_TOUR_STORAGE_KEY);
}
